import { render } from "./DocumentTableView.vue?vue&type=template&id=66db2f63&lang=true"
import script from "./DocumentTableView.vue?vue&type=script&lang=js"
export * from "./DocumentTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__